import { render, staticRenderFns } from "./HeaderSettings.vue?vue&type=template&id=5165be4a&"
import script from "./HeaderSettings.vue?vue&type=script&lang=ts&"
export * from "./HeaderSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports